import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogImage, 
  ogType = 'website',
  structuredData = null 
}) => {
  const defaultTitle = "Dr Mishqah Dollie - Leading Dentist in Ottery, Cape Town | Professional Dental Care";
  const defaultDescription = "Dr Mishqah Dollie provides comprehensive dental care in Ottery, Cape Town. From routine check-ups to emergency dental services, implants, and cosmetic dentistry. Book your appointment today!";
  const defaultKeywords = "dentist ottery cape town, dental clinic ottery, dr mishqah dollie, dental implants cape town, emergency dentist ottery, teeth whitening cape town, dental checkup ottery";
  const defaultOgImage = "/logo192.png";
  
  const businessStructuredData = {
    "@context": "https://schema.org",
    "@type": "Dentist",
    "name": "Dr Mishqah Dollie Dental Practice",
    "alternateName": "Dr Mishqah Dollie",
    "description": "Professional dental care services in Ottery, Cape Town. Offering comprehensive dental treatments including implants, emergency care, and cosmetic dentistry.",
    "url": "https://drmishqahdollie.co.za",
    "telephone": "+27649144852",
    "email": "info@drmishqahdollie.co.za",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "280 Ottery Road, Southern Suburbs",
      "addressLocality": "Ottery",
      "addressRegion": "Cape Town",
      "addressCountry": "ZA",
      "postalCode": "7800"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -34.0083,
      "longitude": 18.5683
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:30",
        "closes": "12:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "14:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "12:00"
      }
    ],
    "priceRange": "$$",
    "paymentAccepted": ["Cash", "Credit Card", "Medical Aid"],
    "currenciesAccepted": "ZAR",
    "medicalSpecialty": "Dentistry",
    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Dental Implants",
        "description": "Permanent tooth replacement solution"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Emergency Dental Care",
        "description": "24/7 emergency dental services"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Teeth Whitening",
        "description": "Professional teeth whitening treatments"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Dental Check-ups",
        "description": "Routine dental examinations and cleanings"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/drdollie_dentist/",
      "https://www.google.com/maps/place/Dr+Mishqah+Dollie"
    ],
    "image": "https://drmishqahdollie.co.za/logo192.png",
    "logo": "https://drmishqahdollie.co.za/logo192.png"
  };

  const finalStructuredData = structuredData || businessStructuredData;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="author" content="Dr Mishqah Dollie" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical || "https://drmishqahdollie.co.za"} />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      <meta property="og:image:alt" content="Dr Mishqah Dollie Dental Practice" />
      <meta property="og:site_name" content="Dr Mishqah Dollie Dental Practice" />
      <meta property="og:locale" content="en_ZA" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={ogImage || defaultOgImage} />
      
      {/* Local Business Meta Tags */}
      <meta name="geo.region" content="ZA-WC" />
      <meta name="geo.placename" content="Ottery, Cape Town" />
      <meta name="geo.position" content="-34.0083;18.5683" />
      <meta name="ICBM" content="-34.0083, 18.5683" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
      
      {/* Additional SEO Meta Tags */}
      <meta name="theme-color" content="#2563eb" />
      <meta name="msapplication-TileColor" content="#2563eb" />
      
      {/* Preconnect to external domains for performance */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://maps.googleapis.com" />
    </Helmet>
  );
};

export default SEO; 